export interface LegalMenuItem {
  url: string;
  title: string;
  legalDocName?: string;
  showPdf?: boolean;
}

export const legalMenuItems: LegalMenuItem[] = [
  {
    url: '/uber-uns/impressum/',
    title: 'Impressum',
    legalDocName: 'legalNotice',
    showPdf: false,
  },
  {
    url: '/uber-uns/agb/',
    title: 'AGB',
    legalDocName: 'termsAndConditions',
    showPdf: true,
  },
  {
    url: '/uber-uns/datenschutz/',
    title: 'Datenschutz',
    legalDocName: 'declarationOfConsentDataProtection',
    showPdf: true,
  },
  {
    url: '/uber-uns/einwilligungserklarung/',
    title: 'Einwilligungserklärung',
    legalDocName: 'declarationOfConsentAdvertising',
    showPdf: false,
  },
  {
    url: '/uber-uns/unsere-partner/liste/',
    title: 'Liste unserer Partner',
    legalDocName: 'creditProvidersAndCreditAgencies',
    showPdf: false,
  },
  {
    url: '/uber-uns/pflichtinformation/vorvertragliche-informationen/',
    title: 'Vorvertragliche Informationen',
    legalDocName: 'mandatoryInformation',
    showPdf: true,
  },
  {
    url: '/uber-uns/dsa-beschwerdeverfahren/',
    title: 'DSA Beschwerdeverfahren',
  },
];
